/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useState } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

import { Chevron } from '../../icons';

export const Dropdown = ({
  trigger,
  align = 'end',
  outline = true,
  arrow = true,
  disabled,
  children,
}) => {
  const onOpenChange = (open) => {
    if (!open) {
      document.body.style.pointerEvents = null;
    }
  };
  return (
    <DropdownMenu.Root
      disabled={disabled}
      modal={false}
      sx={{ position: 'relative' }}
      onOpenChange={onOpenChange}
    >
      <DropdownMenu.Trigger
        sx={{
          fontSize: [0, 0, 0, 1],
          position: 'relative',
          py: outline ? 6 : 0,
          pl: outline ? 7 : 0,
          pr: arrow ? 11 : 0,
          lineHeight: '1.5',
          textAlign: align === 'end' ? 'right' : 'left',
          color: 'text',
          border: outline ? '1px solid' : 0,
          borderColor: 'line',
          whiteSpace: 'nowrap',
          '&:focus': {
            outline: '1px solid accent',
            outlineOffset: '2px',
          },
          '&:focus-visible': {
            color: 'text',
          },
        }}
      >
        {trigger}
        {arrow && (
          <div
            sx={{
              position: 'absolute',
              right: [8],
              top: '50%',
              transform: 'translateY(-30%)',
              width: [6],
              '& > svg': {
                width: '100%',
              },
            }}
          >
            <Chevron />
          </div>
        )}
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          sideOffset={-1}
          align={align}
          style={{
            zIndex: 999,
          }}
          sx={{
            maxHeight: '300px',
            overflow: 'scroll',
            width: '100%',
            backgroundColor: 'bg.0',
            mt: 7,
            position: 'relative',
            border: '1px solid',
            borderColor: 'line',
            '&:focus': {
              outline: `1px solid`,
              outlineColor: '#ff00cc',
              outlineOffset: '0px',
            },
          }}
        >
          {children}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export const DropdownLabel = ({ children, align }) => {
  return (
    <DropdownMenu.Label
      sx={{
        bg: 'bg.4',
        color: 'txt.4',
        px: 6,
        py: 3,
        mt: 8,
        mb: 4,
        '&:first-child': {
          mt: '0px',
        },
        fontSize: 0,
        fontWeight: 700,
        textAlign: align === 'end' ? 'right' : 'left',
      }}
    >
      {children}
    </DropdownMenu.Label>
  );
};

export const DropdownGroup = ({ children }) => {
  return <DropdownMenu.Group sx={{}}>{children}</DropdownMenu.Group>;
};

export const DropdownItem = ({ value, children, align, onSelect }) => {
  return (
    <DropdownMenu.Item
      sx={{
        fontSize: [1, 1, 2, 2],
        px: [7],
        py: [5],
        cursor: 'default',
        textAlign: align === 'end' ? 'right' : 'left',
        '&:focus': {
          outline: 'none',
          backgroundColor: 'accent',
          color: 'txt.4',
        },
      }}
      onSelect={() => onSelect(value)}
    >
      {children}
    </DropdownMenu.Item>
  );
};

// StyledCheckboxItem
//           checked={checked}
//           onCheckedChange={setChecked}
//         >

export const DropdownCheckboxItem = ({ children, align, checked, onCheckedChange }) => {
  return (
    <DropdownMenu.CheckboxItem
      checked={checked}
      onCheckedChange={onCheckedChange}
      sx={{
        fontSize: [1, 1, 2, 2],
        px: [6],
        py: [2],
        cursor: 'default',
        textAlign: align === 'end' ? 'right' : 'left',
      }}
    >
      {children}
    </DropdownMenu.CheckboxItem>
  );
};
